import store from '../../../config/configureStore';
import { filterErrors } from '../activeRules';

export const errorTree = {
  partiesErrors: ['partiesErrors'],
  propertiesErrors: ['propertiesErrors'],
  offensesErrors: [
    'offenseErrors',
    'incOffendersErrors',
    'incVictimErrors',
    'incRelationshipErrors',
    'incPropertiesErrors',
    'arresteesErrors',
  ],
  evidenceErrors: [],
  narrativesErrors: [],
  incIncidentErrors: [],
};

/**
 * The single seam through which validation errors reach the UI.
 *
 * Rules fetched from the API are only SimpleSchema's message catalogue; the
 * predicates always run. Suppressing a rule for a spec version therefore has to
 * happen here, after the errors are produced. Filtering here rather than in the
 * 12 validate/*.js call sites means one place to get right.
 *
 * MUST be used for COUNTS as well as display - CountErrors/ drives badge counts
 * and stepper state, and filtering one without the other shows a stepper
 * flagged with no visible error.
 */
export const getActiveErrors = (errors) => {
  let activeRuleCodes;
  try {
    activeRuleCodes = store?.store?.getState()?.incident?.activeRuleCodes;
  } catch (e) {
    activeRuleCodes = undefined; // fail open
  }
  return filterErrors(errors, activeRuleCodes);
};
